import React, { FC } from 'react';
import { useHistory, useParams } from 'react-router';

import { MfaSingleSessionTabs } from 'src/apps/mfa/pages/single-session/MfaSingleSessionTabs';
import { MfaSingleSessionTabContent } from 'src/apps/mfa/pages/single-session/views/MfaSingleSessionTabContent';
import { REPORT_NOT_FOUND_STATE_KEY } from 'src/apps/mobile-common/consts/MobileCommonConsts';
import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { TableStateProvider } from 'src/common/providers/dashboard/TableStateProvider';
import { SessionViews } from 'src/common/types/WfaSessionViews';

import { MfaSingleSessionHeader } from './header/MfaSingleSessionHeader';

import './MfaSingleSessionPage.scss';

interface IMfaSingleSessionPageProps {
	viewId?: SessionViews;
}

export const MfaSingleSessionPage: FC<IMfaSingleSessionPageProps> = ({
	viewId = SessionViews.OVERVIEW
}) => {
	const history = useHistory();
	const { sessionId } = useParams<{ [key: string]: string }>();

	const onSessionNotFoundCallback = (): void => {
		history.push(RoutesHelper.getMfaDashboardPath(), { [REPORT_NOT_FOUND_STATE_KEY]: true });
	};

	return (
		<div className="mfa-single-session-page">
			<MfaSingleSessionHeader
				sessionId={sessionId}
				onSessionNotFoundCallback={onSessionNotFoundCallback}
			/>
			<MfaSingleSessionTabs viewId={viewId} sessionId={sessionId} />
			<TableStateProvider>
				<MfaSingleSessionTabContent sessionId={sessionId} viewId={viewId} />
			</TableStateProvider>
		</div>
	);
};
